/**
 * Single source of truth for financial tools platforms.
 * Add/remove platforms here only — used by FinancialTools and FinancialReports.
 */
export const FINANCIAL_PLATFORMS = [
  { id: 'smarthub', name: 'SmartHub' },
  { id: 'rixengine', name: 'RixEngine' },
  { id: 'aniview', name: 'Aniview' },
];
